<template lang="pug">
.v-catalog.catalog(v-if="catalog" :class="{'catalog--regular': !catalog.type, 'catalog--simple': catalog.type === 'simple', 'catalog--grid': catalog.type === 'grid'}")
	v-loader(:loading="loading")
	template(v-if="!catalog.type && isSm")
		.catalog__filter-action-mob
			button.catalog__filter-btn-mob.btn.btn--secondary(type="button" @click="openFilter")
				v-svg-icon.btn__icon(icon="filter")
				.btn__text Параметры
				// .btn__counter(v-if="changedFilters && changedFilters.length") {{changedFilters.length}}
				// !!! если посчитать changedFilters, то будет ошибка в консоли ('Maximum recursive updates exceeded'), applyNewFilters будет вызываться многократно
	template(v-if="!catalog")
		.container
			.catalog__placeholder
	template(v-if="catalog")
		.container
			.catalog__header
				sup.catalog__title-sup(v-if="catalog.title.additional") {{catalog.title.additional}}
				.catalog__header-left(v-if="catalog.title")
					button.catalog__btn-back(v-if="isSm && catalog.type !== 'simple'" type="button" @click="goBack")
						v-svg-icon.catalog__btn-back-icon(icon="arrow-back")
					.catalog__title-wrap
						.catalog__title-cover
							h1.catalog__title(v-if="catalog.title.main || catalog.title" ref="title" :class="{'catalog__title--overflow': titleOverflow}") {{catalog.title.main || catalog.title}}
							button.catalog__title-spoiler-btn(type="button" aria-label="Открыть" @click="openTitle")
								v-svg-icon.catalog__title-spoiler-btn-icon(icon="small-chevron")
				.catalog__sort-wrap(v-if="!isSm")
					template(v-if="catalog.sort && !catalog.type")
						v-field(:field="{type: 'sort', label: 'Сортировать по', options: catalog.sort.options}"
								v-model="state.sort"
								@update:model-value="sortChanged")
				.catalog__header-right(v-if="catalog.type === 'simple'")
					v-filter(ref="filterSimple"
							:filters="computedFilters"
							@filter-changed="filterChanged"
							@filter-updated="filterUpdated"
							@request-reset="resetFilter"
							@request-reset-all="resetAllFilters"
							only-tabs
							view="simple")
			.catalog__mob-header(v-if="isSm && catalog.type !== 'simple'")
				template(v-if="$slots['search']")
					.catalog__search
						slot(name="search")
				.catalog__sort-wrap
					template(v-if="catalog.sort && !catalog.type")
						v-field(:field="{type: 'sort', label: 'Сортировать по', options: catalog.sort.options}"
								v-model="state.sort"
								@update:model-value="sortChanged")
		.catalog__wrapper(ref="catalog-wrapper")
			.catalog__filter-panel(v-if="!isSm && !catalog.type && catalog.filters && catalog.filters.length"
					ref="filter-panel"
					:class="{'catalog__filter-panel--sticky': filterPanelIsSticky}")
				.container
					.filter-panel.scrollbar-none
						.filter-panel__items(ref="filter-panel-items")
							template(v-for="(filter, filterIndex) in catalog.filters.filter(filterItem => filterItem.type !== 'links' && filterItem.type !== 'tags' && filterItem.type !== 'tabs-alt')" :key="filterIndex")
								.filter-panel__item-wrap(v-if="filterIndex < limitIndex")
									.filter-panel__item
										button.filter-panel__button.btn(type="button"
												:class="{'filter-panel__button--active': isFilterFilled(filter) && filter.value !== 'all'}"
												@click="openFilter(filter)")
											.btn__text {{filter.label}}
											.btn__text {{getFilterValueLength(filter)}}
											v-svg-icon.filter-panel__button-icon(icon="small-chevron")
										button.filter-panel__close(type="button" @click="resetFilter(filter)")
											v-svg-icon.filter-panel__close-icon(icon="close")
							.filter-panel__item-wrap(ref="more-filters-btn")
								.filter-panel__item
									button.filter-panel__button.btn.btn--outline(type="button" @click="openFilter")
										.btn__text Все
										v-svg-icon.filter-panel__filter-icon(icon="filter")

			.catalog__filter-panel-holder(v-if="!isSm && !catalog.type")

			.catalog__layout
				.container
					.catalog__filter-links(v-if="!isSm && catalog.filters && catalog.filters.length && catalog.filters.findIndex(filter => filter.type === 'links') > -1")
						v-filter(ref="filterLinks"
								:filters="computedFiltersLinks"
								@filter-changed="filterChanged"
								@filter-updated="filterUpdated"
								@request-reset="resetFilter"
								@request-reset-all="resetAllFilters"
								:view="catalog.type"
								field-type="links")
					.catalog__filter-tags(v-if="catalog.tagsArea")
						.catalog__filter-tags-wrap(v-html="catalog.tagsArea")
					.catalog__filter-tags(v-if="catalog.filters && catalog.filters.length && catalog.filters.findIndex(filter => filter.type === 'tags') > -1")
						v-filter(ref="filterTags"
							:filters="computedFiltersTags"
							@filter-changed="filterChanged"
							@filter-updated="filterUpdated"
							@request-reset="resetFilter"
							@request-reset-all="resetAllFilters"
							:view="catalog.type")
					.catalog__overlay(@click="closeFilter(); requestDataLoad(null, true)")
					.catalog__filter(v-if="catalog.filters"
							:class="{'catalog__filter--opened': isFilterOpened}" @click.stop)
						.catalog__filter-wrap.scrollbar.scrollbar--gray
							v-filter(ref="filter"
									:filters="computedFiltersNotLinksAndNotTags"
									@filter-changed="filterChanged"
									@filter-updated="filterUpdated"
									@request-reset="resetFilter"
									@request-reset-all="resetAllFilters"
									@filter-closed="closeFilter"
									:view="catalog.type"
									:loading="loading"
									:show-top="true")
							.catalog__filter-action
								button.catalog__filter-btn.btn.btn--block.btn--primary(type="button" @click="closeFilter(); requestDataLoad(null, true)") Показать
					.catalog__layout-main
						template(v-if="catalog.items && catalog.items.length")
							template(v-if="catalog.type === 'grid'")
								.catalog__big-grid
									.catalog__big-grid-left
										.catalog__cell-big
											a.catalog__grid-item.catalog__grid-item--big(:href="catalog.items[0].link")
												img.catalog__grid-item-image(v-if="catalog.items[0].images" :src="catalog.items[0].images[0].medium" alt="" loading="lazy")
												.catalog__grid-item-main
													.catalog__grid-item-title {{catalog.items[0].name}}
													.catalog__grid-item-price(v-if="catalog.items[0].price")
														v-price(:price="catalog.items[0].price")
									.catalog__big-grid-right
										.catalog__big-grid-right-half
											.catalog__cell-medium
												a.catalog__grid-item(:href="catalog.items[1].link")
													img.catalog__grid-item-image(v-if="catalog.items[1].images" :src="catalog.items[1].images[0].medium" alt="" loading="lazy")
													.catalog__grid-item-main
														.catalog__grid-item-title {{catalog.items[1].name}}
														.catalog__grid-item-price(v-if="catalog.items[1].price")
															v-price(:price="catalog.items[1].price")
											.catalog__cell-small
												a.catalog__grid-item(:href="catalog.items[2].link")
													img.catalog__grid-item-image(v-if="catalog.items[2].images" :src="catalog.items[2].images[0].medium" alt="" loading="lazy")
													.catalog__grid-item-main
														.catalog__grid-item-title {{catalog.items[2].name}}
														.catalog__grid-item-price(v-if="catalog.items[2].price")
															v-price(:price="catalog.items[2].price")
										.catalog__big-grid-right-half
											.catalog__cell-small
												a.catalog__grid-item(:href="catalog.items[3].link")
													img.catalog__grid-item-image(v-if="catalog.items[3].images" :src="catalog.items[3].images[0].medium" alt="" loading="lazy")
													.catalog__grid-item-main
														.catalog__grid-item-title {{catalog.items[3].name}}
														.catalog__grid-item-price(v-if="catalog.items[3].price")
															v-price(:price="catalog.items[3].price")
											.catalog__cell-medium
												a.catalog__grid-item(:href="catalog.items[4].link")
													img.catalog__grid-item-image(v-if="catalog.items[4].images" :src="catalog.items[4].images[0].medium" alt="" loading="lazy")
													.catalog__grid-item-main
														.catalog__grid-item-title {{catalog.items[4].name}}
														.catalog__grid-item-price(v-if="catalog.items[4].price")
															v-price(:price="catalog.items[4].price")
							template(v-else)
								.catalog__items
									.catalog__grid
										template(v-for="(item, index) in catalog.items" :key="index")
											.catalog__cell(:style="{'order': index}")
												.catalog__product-wrap
													.catalog__favorite-action(v-if="!isSm")
														v-favorite-action(:id="item.id" :name="item.name")
													v-product(template="grid" :product="item" :alt-mob="!catalog.type" :form-contact="catalog.formContact" :media="catalog.media" :phones="catalog.phones")
										template(v-if="catalog.horizontalBanner")
											.catalog__horizontal-banner(:style="{'order': horizontalBannerComputedOrder}")
												.horizontal-banner(@click.stop="openModal")
													.horizontal-banner__wrap(:style="{'background': catalog.horizontalBanner.background}")
														.horizontal-banner__main
															img.horizontal-banner__image(:src="catalog.horizontalBanner.image" alt="" loading="lazy")
															.horizontal-banner__text {{catalog.horizontalBanner.text}}
														.horizontal-banner__action
															.horizontal-banner__btn.btn(:class="catalog.horizontalBanner.button.className")
																| {{catalog.horizontalBanner.button.text}}
										template(v-if="$slots['set-slider']")
											.catalog__set-slider(:style="{'order': setSliderComputedOrder}")
												slot(name="set-slider")
										//template(v-if="isXs && state.page && state.page.count > state.page.limit")
										//	.catalog__nav.flc(:style="{'order': catalog.items.length - 1}")
										//		v-page-nav(:page="catalog.page" @navigate="navigate" :view="catalog.type")
										template(v-if="catalog.productBanner")
											.catalog__product-banner(:style="{'order': isXs ? catalog.items.length + 1: catalog.items.length}")
												a.product-banner(:href="catalog.productBanner.link")
													.product-banner__wrap(:style="{'background': catalog.productBanner.background}")
														.product-banner__main
															.product-banner__title {{catalog.productBanner.title}}
															.product-banner__text.flc {{catalog.productBanner.text}}
														.product-banner__action.flc
															.product-banner__btn.btn(:class="catalog.productBanner.button.className")
																| {{catalog.productBanner.button.text}}
														img.product-banner__image(:src="catalog.productBanner.image" alt="" loading="lazy")
										template(v-if="catalog.type === 'simple'")
											.catalog__catalog-link-wrap(:style="{'order': isXs ? catalog.items.length : catalog.items.length + 1}")
												a.catalog__catalog-link(v-if="catalog.catalogLink" :href="catalog.catalogLink")
													img.catalog__catalog-image(:src="catalogImage" alt="" loading="lazy")
													.catalog__catalog-link-btn.btn.btn--gradient
														.btn__text В каталог
														v-svg-icon.btn__icon(icon="slide-right")
						template(v-else)
							.catalog__empty-message(v-if="!catalog.items || !catalog.items.length") Товары не найдены
						template(v-if="catalog.showMoreLink")
							.catalog__nav.flc
								a.page-nav__btn.btn.btn--block(:href="catalog.showMoreLink") Показать еще
						template(v-if="catalog.items && catalog.items.length && state.page && state.page.count > state.page.limit && !catalog.showMoreLink")
							.catalog__nav.flc
								v-page-nav(:page="catalog.page" @navigate="navigate" :view="catalog.type")
</template>

<script>
import controller from '../scripts/controller/controller.js';
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import {mapGetters} from "vuex";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			catalog: null,
			state: {
				page: null,
				sort: null,
				filter: null
			},
			changedFilters: null,
			asideOpen: false,
			catalogImage: "/local/assets/images/catalog.png",
			isFilterOpened: false,
			filterPanelIsSticky: false,
			limitIndex: Infinity,
			titleOverflow: false
		};
	},

	computed: {
		...mapGetters({
			country: 'delivery/country',
			currency: 'delivery/currency'
		}),

		computedFilters() {
			return this.catalog.filters;
		},

		computedFiltersTags() {
			return this.catalog.filters.filter(filter => filter.type === 'tags');
		},

		computedFiltersLinks() {
			return this.catalog.filters.filter(filter => filter.type === 'links');
		},

		computedFiltersNotLinksAndNotTags() {
			return this.catalog.filters.filter(filter => filter.type !== 'links' && filter.type !== 'tags');
		},

		horizontalBannerComputedOrder() {
			let order;
			if (this.isSm) {
				order = 6;
			} else {
				order = 8;
			}
			if (this.catalog.items.length <= order) {
				return this.catalog.items.length;
			} else {
				return order - 1;
			}
		},

		setSliderComputedOrder() {
			let order;
			if (this.isSm) {
				order = 6 + 4;
			} else {
				order = 8 + 4;
			}
			if (this.catalog.items.length <= order) {
				return this.catalog.items.length;
			} else {
				return order - 1;
			}
		}
	},

	created() {
		window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		controller.events.on('open-filter', this.openFilter);
		window.addEventListener('resize', this.handleResize, controller.passiveEventsSupported ? {passive: true} : undefined);
	},

	watch: {
		country() {
			this.requestDataLoad();
		},

		currency() {
			this.requestDataLoad();
		}
	},

	unmounted() {
		window.removeEventListener('resize', this.handleResize);
	},

	methods: {
		goBack() {
			window.history.back();
		},

		handleScroll() {
			if (this.$refs['filter-panel'] && window.scrollY > this.$el.offsetTop + this.$refs['catalog-wrapper'].offsetTop) {
				this.filterPanelIsSticky = true;
			} else {
				this.filterPanelIsSticky = false;
			}
		},

		getFilterValueLength(filter) {
			if (Array.isArray(filter.value) && filter.value.length > 0) {
				return `: ${filter.value.length}`;
			} else {
				return '';
			}
		},

		scrollToField(fieldId) {
			let $field = document.querySelector(`[data-filter-id="${fieldId + ''}"]`);
			if ($field) {
				$field.scrollIntoView({
					behavior: 'smooth'
				});
			}
		},

		openFilter(filter) {
			document.body.classList.add('state--filter-open');
			this.isFilterOpened = true;
			controller.lockScrolling(document.querySelectorAll('.catalog__filter-wrap, .field-check-list__collapse-wrap'));
			if (filter && filter.id) {
				setTimeout(() => {
					this.scrollToField(filter.id);
					controller.openField(filter.id);
				}, 400)
			}
		},

		closeFilter() {
			document.body.classList.remove('state--filter-open');
			this.isFilterOpened = false;
			controller.unlockScrolling(document.querySelectorAll('.catalog__filter-wrap, .field-check-list__collapse-wrap'));
		},

		isFilterFilled(filter) {
			if (!filter.value ||
					(Array.isArray(filter.value) && filter.value.length === 0) ||
					(filter.type === 'range' && !filter.value.min && !filter.value.max)) {
				return false;
			} else {
				return true;
			}
		},

		dataSet(data, options = {}) {
			if (options && options.append && this.catalog && this.catalog.items) {
				let oldItems = this.catalog.items;
				if (data.filters && data.filters.findIndex(filter => filter.links === true) > -1) {
					let filterLinks = JSON.parse(JSON.stringify(data.filters.find(filter => filter.links === true)));
					filterLinks.name = 'FAKE_LINKS';
					filterLinks.type = 'links';
					filterLinks.autosubmit = true;
					data.filters.push(filterLinks);
				}
				this.catalog = data;
				this.catalog.items = oldItems.concat(this.catalog.items);
			} else {
				if (!this.remoteSet && !this.catalog && data.remoteSet) {
					this.remoteSet  = data.remoteSet;
				}
				if (data.filters && data.filters.findIndex(filter => filter.links === true) > -1) {
					let filterLinks = JSON.parse(JSON.stringify(data.filters.find(filter => filter.links === true)));
					filterLinks.name = 'FAKE_LINKS';
					filterLinks.type = 'links';
					filterLinks.autosubmit = true;
					data.filters.push(filterLinks);
				}
				this.catalog = data;
			}
			if (this.remoteSet && this.catalog.remoteSet && this.remoteSet !== this.catalog.remoteSet) {
				history.pushState(this.catalog.remoteSet, this.catalog.seo.title, this.catalog.remoteSet);
				this.remoteSet = this.catalog.remoteSet;
				if (this.catalog.seo) {
					if (document.title !== this.catalog.seo.title) {
						document.title = this.catalog.seo.title;
					}
					if (!document.querySelector('meta[name="description"]')) {
						let meta = document.createElement('meta');
						meta.name = 'description';
						document.getElementsByTagName('head')[0].appendChild(meta);
					}
					if (!document.querySelector('meta[name="keywords"]')) {
						let meta = document.createElement('meta');
						meta.name = 'keywords';
						document.getElementsByTagName('head')[0].appendChild(meta);
					}
					if (this.catalog.seo.robots && document.querySelector('meta[name="robots"]')) {
						document.querySelector('meta[name="robots"]').setAttribute('content', this.catalog.seo.robots);
					} else if (this.catalog.seo.robots && !document.querySelector('meta[name="robots"]')) {
						let meta = document.createElement('meta');
						meta.name = 'robots';
						document.getElementsByTagName('head')[0].appendChild(meta);
						document.querySelector('meta[name="robots"]').setAttribute('content', this.catalog.seo.robots);
					} else if (!this.catalog.seo.robots && document.querySelector('meta[name="robots"]')) {
						document.querySelector('meta[name="robots"]').remove();
					}
					if (this.catalog.seo.canonical && document.querySelector('link[rel="canonical"]')) {
						document.querySelector('link[rel="canonical"]').setAttribute('href', this.catalog.seo.canonical);
					} else if (this.catalog.seo.canonical && !document.querySelector('link[rel="canonical"]')) {
						let meta = document.createElement('link');
						meta.rel = 'canonical';
						meta.href = this.catalog.seo.canonical;
						document.getElementsByTagName('head')[0].appendChild(meta);
					} else if (!this.catalog.seo.canonical && document.querySelector('link[rel="canonical"]')) {
						document.querySelector('link[rel="canonical"]').remove();
					}
					document.querySelector('meta[name="description"]').setAttribute('content', this.catalog.seo.description);
					document.querySelector('meta[name="keywords"]').setAttribute('content', this.catalog.seo.keywords);
					if (document.querySelector('#bx-panel')) {
						document.querySelector('#bx-panel').remove();
					}
				}
			}
			this.state.sort = this.catalog.sort ? this.catalog.sort.value : null;
			this.state.page = this.catalog.page;
			this.$nextTick(() => {
				this.$nextTick(() => {
					this.handleScroll();
				});
			});

			this.$nextTick(() => {
				this.$nextTick(() => {
					this.calculateLimitIndex();
					window.addEventListener('resize', this.calculateLimitIndex, controller.passiveEventsSupported ? {passive: true} : undefined);
					this.handleResize();
				});
			});
		},

		handleResize() {
			this.titleOverflow = false;
			this.$nextTick(() => {
				let overlapHeight = 62.4;
				if (this.isSm) {
					overlapHeight = 40;
				}
				const titleHeight = this.$refs['title'].getBoundingClientRect().height;
				if (titleHeight > overlapHeight) {
					this.titleOverflow = true;
				} else {
					this.titleOverflow = false;
				}
			});
		},

		openTitle() {
			this.titleOverflow = false;
		},

		calculateLimitIndex() {
			if (!this.isSm) {
				this.limitIndex = Infinity;
				this.$nextTick(() => {
					let $filterPanelItems = this.$refs['filter-panel-items'];
					if ($filterPanelItems) {
						let $itemWraps = this.$el.querySelectorAll('.filter-panel__item-wrap');
						let filterPanelItemsWidth = $filterPanelItems.getBoundingClientRect().width;
						let $moreFiltersBtn = this.$refs['more-filters-btn'];
						let accWidth = $moreFiltersBtn.getBoundingClientRect().width;
						$itemWraps.forEach(($filterPanelItem, $filterPanelItemIndex) => {
							let filterPanelItemWidth = $filterPanelItem.getBoundingClientRect().width;
							accWidth += filterPanelItemWidth;
							if (this.limitIndex === Infinity && accWidth > filterPanelItemsWidth) {
								this.limitIndex = $filterPanelItemIndex;
							}
						});
					}
				});
			}
		},

		innerWidth(el, value) {
			if (value === undefined) {
				return el.clientWidth;
			} else {
				el.style.width = value;
			}
		},

		navigate(page) {
			this.state.page.offsetPrev = this.state.page.offset;
			this.state.page.offset = page.offset;
			this.state.page.limit = page.limit;
			this.requestDataLoad({append: page.append});
		},

		sortChanged() {
			this.state.page.offset = 0;
			this.requestDataLoad();
		},

		filterUpdated(filterValue, changedFilters) {
			this.state.filter = filterValue;
			this.changedFilters = changedFilters;
			// update url except markup pages
			if (window.location.pathname.indexOf('/local/') < 0) {
				window.history.replaceState(null, null, this.catalog.remote);
			}
		},

		filterChanged(filterValue, changedFilters, autosubmit) {
			this.state.filter = filterValue;
			if (autosubmit) {
				this.requestDataLoad(null, true);
			}
		},

		requestDataLoad(dataSetOptions, isFilterChanged) {
			if (this.catalog) {
				this.dataLoad({
					url: this.catalog.remote,
					delay: true,
					data: {
						page: this.state.page,
						sort: this.state.sort,
						filter: this.state.filter,
						country: this.country.value,
						currency: this.currency.value,
						isFilterChanged: isFilterChanged || false
					}
				}, dataSetOptions);
			}
		},

		resetFilter(filter) {
			this.$refs.filter.resetFilter({id: filter.id, silent: false});
		},

		resetAllFilters(e) {
			this.$refs.filter.resetAll(e);
		},

		openModal() {
			controller.openModal({
				className: 'modal--md',
				component: {
					name: 'v-form',
					props: {
						dataSource: this.catalog.form,
						media: this.catalog.media,
						phones: this.catalog.phones,
						className: 'call-back'
					}
				}
			});
		},
	}
};
</script>